import {AfterContentInit, Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {FormControl} from "@angular/forms";
import {catchError, throwError} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import dayjs from "dayjs";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { PinType } from 'src/app/models/pinType';
import { PIN_ICONS } from '../new-save-pin/new-save-pin.component';
import { PinManagerService } from 'src/app/services/pin-manager.service';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { SeasonManagerService } from 'src/app/services/season-manager.service';

export const MY_FORMATS = {
    parse: {
      dateInput: "YYYY-MM-DD"
    },
    display: {
      dateInput: "YYYY-MM-DD",
      monthYearLabel: "YYYY-MM-DD",
      dateA11yLabel: "YYYY-MM-DD",
      monthYearA11yLabel: "YYYY-MM-DD"
    }
  };

@Component({
    selector: 'app-pin-export-filter',
    templateUrl: './pin-export-filter.component.html',
    styleUrls: ['./pin-export-filter.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PinExportFilterComponent implements OnInit {

  pinType: PinType;
  defaultPin: any;
  farm: any;
  field: any;
  pintypeId: string = '0';
  selectedPin: number = 0;
  pinIcons = PIN_ICONS;
  pinTypesList: PinType[];
  excludedId:number = 9; //N tester pin Id

  showFarmDropdown = false;
  showFieldDropdown = false;
  showPinTypeDropdown = false;


    farms = new FormControl([]);
    fields = new FormControl([]);
    pinTypes = new FormControl([]);
    filterFromDate = new FormControl();
    filterToDate  = new FormControl();

    selectedFarmIds = [];
    selectedFieldIds = [];
    selectedPinTypeIds = [];
    selectedPinTypes: any[] = [];
    selectedFarms: any[] = [];
    selectedFields: any[] = [];
    
    // Track previous selections for "All" logic
    previousFarms: any[] = [];
    previousFields: any[] = [];
    previousPinTypes: any[] = [];
    farmList: any[] = [];
    fieldList: any[] = [];
    allFieldsList: any[] = [];
    fromDate: string;
    toDate: string;
  
    protected readonly dayjs = dayjs;

    dateStringFormatting = 'YYYY-MM-DD';

    constructor( @Inject(MAT_DIALOG_DATA) public data: any,
                 public dialogRef: MatDialogRef<PinExportFilterComponent>,

                 private pinManagerService: PinManagerService,
                 public nav: NavBarComponent,
                 private seasonManagerService: SeasonManagerService,
    ) {


    }
    ngOnInit(): void {
      this.populateFarmsDropdownDetails();
      this.populateFieldsDropdownDetails();
      this.populatePinTypesListDropDown();
      this.setDateDefault();
  }

    cancelFilering(){
        this.dialogRef.close();
    }


    setfilterFromDate(event: MatDatepickerInputEvent<Date>): void {
      this.fromDate = event.target?.value ? dayjs(event.target?.value).format('YYYY-MM-DD') : '';
    }
    
    setfilterToDate(event: MatDatepickerInputEvent<Date>): void {
        this.toDate = event.target?.value ? dayjs(event.target?.value).format('YYYY-MM-DD') : '';
    }


    applyFilering() {
       this.nav.toggleLoading(true);
       let defaultfromDate = dayjs().subtract(12, 'month').format('YYYY-MM-DD');
      let defaulttoDate = dayjs().format('YYYY-MM-DD');
      
      // Extract IDs, filter out null values
      const farmIds = this.selectedFarms?.map(f => f.id).filter(id => id !== null) || [];
      const fieldIds = this.selectedFields?.map(f => f.fieldId).filter(id => id !== null) || [];
      const pinTypeIds = this.selectedPinTypes?.map(p => p.id).filter(id => id !== null) || [];
      
        const filterValues = {
            farmId: farmIds.length > 0 ? farmIds : null,
            fieldId: fieldIds.length > 0 ? fieldIds : null,
            pinTypeId: pinTypeIds.length > 0 ? pinTypeIds : null,
            fromDate: this.fromDate ? this.fromDate : defaultfromDate,
            toDate:  this.toDate ? this.toDate : defaulttoDate,
            isCsvDownload: this.data?.isCsvDownload,
            isShpFileDownload: this.data?.isShpFileDownload
        }
        this.dialogRef.close(filterValues);
    }



  populateFarmsDropdownDetails(){
    this.nav.toggleLoading(true);

    let tenantId = Number(sessionStorage.getItem("selectedTenant"));
  
    this.pinManagerService.getfarmsByTenantId(tenantId).pipe(
        catchError(error =>{
          console.error();
          return throwError(()=> error);
        })
    ).subscribe((response) =>{
      // Filter out farms with missing or empty names
      this.farmList = response?.filter(farm => farm?.name && farm.name.trim() !== '') || [];
       this.setFarmDefault();

      if(this.farmList == null){
          return;
      }
      setTimeout(()=> {
          this.nav.toggleLoading(false);
      },1400)

    });

  }

populateFieldsDropdownDetails(){
    this.nav.toggleLoading(true);

    let tenantId = Number(sessionStorage.getItem("selectedTenant"));
  
    this.pinManagerService.getfieldsByTenantId(tenantId, []).pipe(
        catchError(error =>{
            console.error(error);
            return throwError(()=> error);
        })
    ).subscribe((response) =>{
        // Filter out fields with missing or empty names
        this.allFieldsList = response?.filter(field => field?.name && field.name.trim() !== '') || [];
        this.fieldList = this.allFieldsList;
         this.setFieldDefault();

      if(this.fieldList == null){
            return;
        }
        setTimeout(()=> {
            this.nav.toggleLoading(false);
        },1200)
    });
}

onFarmSelectionChange(selectedFarms: any[]){
  const hasAll = selectedFarms.some(f => f.id === null);
  const hadAll = this.previousFarms.some(f => f.id === null);
  
  if (hasAll && selectedFarms.length > 1) {
    // Determine what was just clicked
    const wasAllJustClicked = hasAll && !hadAll;
    
    if (wasAllJustClicked) {
      // "All" was just clicked - keep only "All"
      const allOption = selectedFarms.find(f => f.id === null);
      this.selectedFarms = [allOption];
    } else {
      // Another option was clicked while "All" was selected - remove "All"
      this.selectedFarms = selectedFarms.filter(f => f.id !== null);
    }
  } else {
    this.selectedFarms = selectedFarms;
  }
  
  this.previousFarms = [...this.selectedFarms];
  this.selectedFarmIds = this.selectedFarms?.map(f => f.id).filter(id => id !== null) || [];
  this.filterFieldsBySelectedFarms();
}

filterFieldsBySelectedFarms(){
    if(this.selectedFarmIds && this.selectedFarmIds.length > 0){
        this.fieldList = this.allFieldsList.filter((field) => {
            return this.selectedFarmIds.includes(field?.farmId);
        });
    } else {
        this.fieldList = this.allFieldsList;
    }
    // Reset field selection to "All" after filtering
    this.setFieldDefault();
}


  populatePinTypesListDropDown() {
    this.pinManagerService.getPinTypesList().pipe(
      catchError((error) => {
        console.error(error);
        return throwError(() => error);
      })
    )
      .subscribe((response) => {
        // Filter out pin types with missing or empty names
        this.pinTypesList = response?.filter(pinType => pinType?.name && pinType.name.trim() !== '') || [];
      
        if (document?.title === 'SGS Precision Gateway') {
          this.pinTypesList = this.pinTypesList.filter(item => item.id !== this.excludedId);
        }
        this.setPindefault();

        this.nav.toggleLoading(false);
      });
  }


    setDateDefault(){
    //DATES
    const defaultfromDate = dayjs().subtract(12, 'month').format('YYYY-MM-DD');
    this.filterFromDate.setValue(defaultfromDate);
    const defaulttoDate = dayjs().format('YYYY-MM-DD');
    this.filterToDate.setValue(defaulttoDate);
  }


  setFarmDefault(){
    //Farms
        this.farm = {
        id: null,
        name: 'All',
        active: true,
        country: null,
        province: null,
        size: null
    }

    if(!this.farmList.find((farm) => farm?.id === null)){
        this.farmList.unshift(this.farm);
      }
        
    // Sort with "All" first, then alphabetical
    this.farmList.sort((a, b) => {
        if (a.id === null) return -1;
        if (b.id === null) return 1;
        return a.name.localeCompare(b.name);
    });
        setTimeout(() => {
            const allFarm = this.farmList.find((farm) => farm?.id === null);
            this.selectedFarms = allFarm ? [allFarm] : [];
            this.previousFarms = [...this.selectedFarms];
        }, 100);
  }

  setFieldDefault(){
    //FIELDS
      this.field = {
          farmId: null,
          fieldId: null,
          name: 'All',
          active: true,
          size: null
      }
      if(!this.fieldList.find((field) => field?.fieldId === null)){
        this.fieldList.unshift(this.field);
      }

          
    // Sort with "All" first, then alphabetical
    this.fieldList.sort((a, b) => {
        if (a.fieldId === null) return -1;
        if (b.fieldId === null) return 1;
        return a.name.localeCompare(b.name);
    });
       
        
        setTimeout(() => {
            const allField = this.fieldList.find((field) => field?.fieldId === null);
            this.selectedFields = allField ? [allField] : [];
            this.previousFields = [...this.selectedFields];
        }, 100);
  }

  setPindefault(){
      this.defaultPin = {
          id: null,
          name: 'All',
          dateModified: ''
      }

      if(!this.pinTypesList.find((pinType) => pinType?.id === null)){
        this.pinTypesList.unshift(this.defaultPin);
      }

        setTimeout(() => {
            const allPinType = this.pinTypesList.find((pinType) => pinType?.id === null);
            this.selectedPinTypes = allPinType ? [allPinType] : [];
            this.previousPinTypes = [...this.selectedPinTypes];
        }, 100);
  }

  onFieldSelectionChange(selectedFields: any[]){
    const hasAll = selectedFields.some(f => f.fieldId === null);
    const hadAll = this.previousFields.some(f => f.fieldId === null);
    
    if (hasAll && selectedFields.length > 1) {
      const wasAllJustClicked = hasAll && !hadAll;
      
      if (wasAllJustClicked) {
        // "All" was just clicked - keep only "All"
        const allOption = selectedFields.find(f => f.fieldId === null);
        this.selectedFields = [allOption];
      } else {
        // Another option was clicked while "All" was selected - remove "All"
        this.selectedFields = selectedFields.filter(f => f.fieldId !== null);
      }
    } else {
      this.selectedFields = selectedFields;
    }
    
    this.previousFields = [...this.selectedFields];
  }

  onPinTypeSelectionChange(selectedPinTypes: any[]){
    const hasAll = selectedPinTypes.some(p => p.id === null);
    const hadAll = this.previousPinTypes.some(p => p.id === null);
    
    if (hasAll && selectedPinTypes.length > 1) {
      const wasAllJustClicked = hasAll && !hadAll;
      
      if (wasAllJustClicked) {
        // "All" was just clicked - keep only "All"
        const allOption = selectedPinTypes.find(p => p.id === null);
        this.selectedPinTypes = [allOption];
      } else {
        // Another option was clicked while "All" was selected - remove "All"
        this.selectedPinTypes = selectedPinTypes.filter(p => p.id !== null);
      }
    } else {
      this.selectedPinTypes = selectedPinTypes;
    }
    
    this.previousPinTypes = [...this.selectedPinTypes];
  }

  compareWith(o1: any, o2: any): boolean {
    const id1 = o1?.id !== undefined ? o1.id : o1?.fieldId;
    const id2 = o2?.id !== undefined ? o2.id : o2?.fieldId;
    return id1 === id2;
  }

  isFarmSelected(farm: any): boolean {
    return this.selectedFarms?.some(f => f.id === farm.id) || false;
  }

  isFieldSelected(field: any): boolean {
    return this.selectedFields?.some(f => f.fieldId === field.fieldId) || false;
  }

  isPinTypeSelected(pt: any): boolean {
    return this.selectedPinTypes?.some(p => p.id === pt.id) || false;
  }

  toggleFarmSelection(farm: any) {
    if (this.isFarmSelected(farm)) {
      this.selectedFarms = this.selectedFarms.filter(f => f.id !== farm.id);
    } else {
      this.selectedFarms = [...this.selectedFarms, farm];
    }
    this.onFarmSelectionChange(this.selectedFarms);
  }

  toggleFieldSelection(field: any) {
    if (this.isFieldSelected(field)) {
      this.selectedFields = this.selectedFields.filter(f => f.fieldId !== field.fieldId);
    } else {
      this.selectedFields = [...this.selectedFields, field];
    }
    this.onFieldSelectionChange(this.selectedFields);
  }

  togglePinTypeSelection(pt: any) {
    if (this.isPinTypeSelected(pt)) {
      this.selectedPinTypes = this.selectedPinTypes.filter(p => p.id !== pt.id);
    } else {
      this.selectedPinTypes = [...this.selectedPinTypes, pt];
    }
    this.onPinTypeSelectionChange(this.selectedPinTypes);
  }

}
